module.exports = __webpack_public_path__ + "static/media/ajax-Loader.47ae4369.gif";